exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#gridComponent[data-v-5aac5336] {\n  width: 978px;\n  font-family: 'Asap', sans-serif;\n}\n.v-title[data-v-5aac5336] {\n  margin-bottom: 20px;\n}\nh2[data-v-5aac5336] {\n  font-weight: normal;\n  margin: 12px 0px 0px;\n}\n.divTextDetail[data-v-5aac5336] {\n  margin-right: 1%;\n  font-weight: 500;\n  font-size: 1.3rem;\n}\n.divTextDetailValue[data-v-5aac5336] {\n  margin-right: 1%;\n  font-size: 1.2rem;\n}\n", ""]);

// exports
